import { httpClient } from '@connectors/HttpClient'

import type { MfaSchoolRequirement } from '../types'

export const MfaSchoolRequirementService = {
    get: async (id: string): Promise<any> => {
        const response = await httpClient.axios.get(`/admin/mfa-school-requirement/${id}`)
        return response.data
    },
    create: async (params: Partial<MfaSchoolRequirement>): Promise<any> => {
        const response = await httpClient.axios.post('/admin/mfa-school-requirement', params)
        return response.data
    },
    update: async (id: string, params: Partial<MfaSchoolRequirement>): Promise<any> => {
        const response = await httpClient.axios.put(`/admin/mfa-school-requirement/${id}`, params)
        return response.data
    },
    delete: async (id: string): Promise<any> => {
        const response = await httpClient.axios.delete(`/admin/mfa-school-requirement/${id}`)
        return response.data
    }
}
